import React, { Component } from 'react'
import ReactStars from 'react-stars'
import {apiInstance, orders_api } from "../../actions/http"
import {getToken} from "../../store";

export default class StarRate extends Component {
    
    constructor(props){
        super(props);
        this.state = {
            rating: props.rating
        };
        this.ratingChanged = this.ratingChanged.bind(this);
    }

    ratingChanged(rating) {
        let {id} = this.props;
        let token = getToken();
        apiInstance({
            method: "POST",
            url: orders_api + id + "/order_rating/",
            data: {rating},
            headers: {
                "Authorization": `Token ${token}`,
                "Content-type": "application/json"
            }
        })
        this.setState({rating});
    }

    render() {
        return (
            <ReactStars
                count={5}
                onChange={this.ratingChanged}
                size={40}
                value={this.state.rating}
                color2={'#ffd700'} 
            />
        )
    }
}
